import { render, staticRenderFns } from "./HousingFormEdit.vue?vue&type=template&id=b18a0d84&"
import script from "./HousingFormEdit.vue?vue&type=script&lang=js&"
export * from "./HousingFormEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports